import React from 'react';

import Mark from '../assets/img/logo-white.svg';

/**
 * Marque ClickChauffeur : le nom en texte (« Click » blanc, « Chauffeur » bleu) suivi du
 * pictogramme à droite — même composition que l'ancien wordmark en PNG, mais net à toute
 * densité d'écran et avec une seule source pour la couleur d'accent (.cc-brand-accent).
 *
 * Variante détourée du pictogramme (logo-white.svg, sans le disque bleu) : ces pages sont
 * posées sur le fond « night », le disque y ferait une pastille pleine à côté du texte.
 * À réserver aux fonds sombres — sur fond clair, utiliser logo.svg.
 *
 * Le pictogramme est décoratif : le nom accessible du lien vient du texte.
 *
 * Le conteneur centre et porte l'espacement ; l'ancre, elle, s'ajuste au contenu, pour que la
 * zone cliquable se limite au texte et au pictogramme et ne s'étende pas sur toute la largeur.
 */
export default ({href = 'https://clickchauffeur.com', className = ''}) => {
  const lockup = (
    <span className="cc-brand">
      <span className="cc-brand-word">Click<span className="cc-brand-accent">Chauffeur</span></span>
      <img src={Mark} alt="" aria-hidden="true" className="cc-brand-mark"/>
    </span>
  );

  return (
    <div className={`cc-brand-wrap ${className}`.trim()}>
      {href ? <a href={href} className="cc-brand-link">{lockup}</a> : lockup}
    </div>
  );
};
